import LegendTable from './LegendTable';

export default LegendTable;

export type { ILegendTableProps, ILegendTableRow, LegendTableDensity } from './LegendTable';
